/**
 * 上传图片组件 仿 antd 样式 TODO 改用antd上传组件
 * Author: FJJ
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/05/19     1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 *
 * @param onChange          回调数据
 * @param accept            可选接受类型：格式 '.pdf, .jpg, .jpeg, .png',
 * @param flagLimitType     是否限制为当时已有数据类型,默认False,为Ture时，若当时有文件列表数据，即只接受当前文件列表数据的类型
 * @param placeholder       上传框内的默认文案
 * @param disabled          ！！！！！不可编辑 临时加的，暂时确定普通类型可用，其他类型如身份证 使用时注意是否有效，如无效自行补全
 *
 *  辅助参数
 *  @param maxCount 最大上传数，默认1
 *  @param styleUpload 配置上传样式：'avatar':头像样式，'RU_IDcard':俄罗斯身份证示例样式 todo 待补充示例图片
 * */
import React from 'react';
import {Modal, message, Button, Spin} from 'antd';
import { fexWebUploaderConfig } from "@config/upload";
import {isEmpty,trim,getFileSuffix} from '@utils/utils';
import Lang from "@/components/Lang/Lang";
import "./index.less";
import {renderFileType} from "./file.util";

const WebUploader = window.WebUploader;
class UploadImageComponent extends React.Component {
    static defaultProps = {
        accept:'*',
        flagLimitType:false,
        multiple:true,
        initValue:[],
        maxCount:1,
        styleUpload:'',
        fileSizeLimit: 5*1024*1024,
        styleName:'',
        placeholder:"", // 上传框内的默认文案
        disabled:false, // 不可编辑 默认编辑状态
    };
    constructor(props) {
        super(props);
        this.state = {
            file: '',
            fileList:props.initValue,
            accept: props.accept,
            flagLimitType: props.flagLimitType,
            loading: false,
        };
    }
    init(successFn) {
        const fileConfig = {
            ...fexWebUploaderConfig,
            accept:this.props.accept,
            fileSingleSizeLimit:this.props.fileSizeLimit,
            auto: true,
        }
        this.uploader = WebUploader.create( fileConfig );
        this.uploader.onUploadSuccess = function (file, response) {
            successFn && successFn(file, response);
        };
        this.uploader.onError = function (file, response) {
            successFn && successFn(file, response);
        };
        // this.uploader.on('uploadError', (file,response)=> {
        //     console.log("uploadError")
        //     // message.warning(Lang({id:"ShangChuanShiBai2",default:"上传失败"}));
        //     successFn && successFn(file, {success:false,data:response});
        // });
    }
    /****
     * 通用检查类型
     * 格式 可能是 jpg || .jpg
     * **/
    checkType(resoureType=''){
        let sType = '';
        if(resoureType.indexOf('xls')> -1||resoureType.indexOf('xls')> -1){
            sType = 'document';
        }else if(resoureType.indexOf('pdf')> -1||resoureType.indexOf('PDF')> -1){
            sType = 'document';
        }else if(resoureType.indexOf('doc')> -1||resoureType.indexOf('DOC')> -1){
            sType = 'document';
        }else if(resoureType.indexOf('png')> -1||resoureType.indexOf('PNG')> -1) {
            sType = 'pic';
        }else if(resoureType.indexOf('gif')> -1||resoureType.indexOf('GIF')> -1) {
            sType = 'pic';
        }else if(resoureType.indexOf('jpg')> -1||resoureType.indexOf('JPG')> -1) {
            sType = 'pic';
        }else if(resoureType.indexOf('jpeg')> -1||resoureType.indexOf('JPEG')> -1) {
            sType = 'pic';
        }
        return sType;
    }
    /**
     * 灵活修改 当前可接受的文件类型
     **/
    setAccept(file){
        const { accept, flagLimitType } = this.state;
        if(flagLimitType){
            let limitAccept = accept;
            const sFileUrl = file.fileUrl||'';
            const sSuffix = getFileSuffix(sFileUrl);
            const sType = this.checkType(sSuffix);
            const acceptlist = limitAccept.split(',');
            let sNewAccpt = '';
            acceptlist.forEach(typeAcc=>{
                const currType =  this.checkType(typeAcc);
                if(currType==sType) sNewAccpt += typeAcc+',';
            })
            this.setState({
                accept:sNewAccpt,
            })
        }
    }
    fileRemove(inx,file){
        let newFileList = [ ...this.state.fileList];
        newFileList.splice(inx,1);
        this.props.onChange(newFileList);
        this.setState({
            // accept:newAccept,
            fileList: newFileList,
        });
    }
    /**
     * 预览
     * */
    handleCancel = () => this.setState({ previewVisible: false });
    handlePreview = fileName => {
        const fileType = fileName?getFileSuffix(fileName):"";
        if(fileType.indexOf('jpeg')> -1||fileType.indexOf('jpg')> -1||fileType.indexOf('png')> -1||fileType.indexOf('bmp')> -1||fileType.indexOf('gif')> -1) {
            this.setState({
                previewImage: fileName,
                previewVisible: true,
            });
        }else window.open(fileName)
    };
    /**
     * render list
     * */
    renderList(list=[],accept='*'){
        let child = []
        const {disabled,} = this.props;
        list.forEach((item,inx)=>child.push(<div className={"ant-upload-list-picture-card-container"} key={"um_"+inx}>
                        <span>
                            <div className={"ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card"}>
                                <div className="ant-upload-list-item-info">
                                    <span><a
                                        className="ant-upload-list-item-thumbnail"
                                        target="_blank" rel="noopener noreferrer">
                                        {/*<img src={item.fileUrl} className="ant-upload-list-item-image" />*/}
                                        {item.fileUrl?renderFileType(item.fileUrl):null}
                                        </a>
                                    </span>
                                </div>
                                <span className="ant-upload-list-item-actions">
                                    {!disabled&&<label className="ri-edit-box-line color-white cursor-p">
                                      <input type="file" style={{ display: 'none' }} onChange={(e)=>this.upload(e,inx)} accept={accept} />
                                    </label>}
                                    {item.fileUrl&&<span className={'action ml_6 cursor-p'} onClick={()=>this.handlePreview(item.fileUrl)}><i className="ri-eye-line color-white"> </i></span>}
                                    {!disabled&&<span className={'action ml_4'} onClick={()=>this.fileRemove(inx)}><i className="ri-delete-bin-6-line color-white cursor-p"> </i></span>}
                                </span>

                            </div>
                        </span>
        </div>))
        return child;
    }
    /**
     * render one
     * */
    renderOne(item={},accept='*',inx=0,){
        const {disabled,} = this.props;
        let child = [];
        return (<div className={"ant-upload-list-picture-card-container"}>
                    <span>
                        <div className={"ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card"}>
                            <div className="ant-upload-list-item-info">
                                <span><a className="ant-upload-list-item-thumbnail" target="_blank" rel="noopener noreferrer">
                                    {/*<img src={item.fileUrl} className="ant-upload-list-item-image" />*/}
                                    {item.fileUrl?renderFileType(item.fileUrl):null}
                                    </a>
                                </span>
                            </div>
                            <span className="ant-upload-list-item-actions">
                                {!disabled&&<label className="ri-edit-box-line color-white cursor-p">
                                  <input type="file" style={{ display: 'none' }} onChange={(e)=>this.upload(e,inx)} accept={accept} />
                                </label>}
                                {item.fileUrl&&<span className={'action ml_6 cursor-p'} onClick={()=>this.handlePreview(item.fileUrl)}><i className="ri-eye-line color-white"> </i></span>}
                                {!disabled&&<span className={'action ml_4'} onClick={()=>this.fileRemove(0)}><i className="ri-delete-bin-6-line color-white cursor-p"> </i></span>}
                            </span>
                        </div>
                    </span>
            <p>{__getServerLanguage("ShangChuanTuPian")}</p>
        </div>)
        return child;
    }
    // 上传
    upload(e,inx=0){
        if(e&&e.target&&e.target.files&&e.target.files[0]){
            const flag = this.beforeUpload(e.target.files[0],e.target.files,)
            if(flag){
                this.loading(true);
                this.uploader.addFile(e.target.files[0]);
                this.setState({
                    loadInx: inx
                })
            }
        }
    }
    showAccept(types=''){
        let str =''
        const arr = types.split(',')
        arr.forEach((item,inx)=>str += (inx>0?'/'+getFileSuffix(item):getFileSuffix(item)))
        return str
    }
    formatBytes(bytes,decimals) {
        if(bytes == 0) return '0 Byte';
        var k = 1024;
        var dm = decimals + 1 || 3;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
    // 上传前置
    beforeUpload(file, files=[]){
        const { flagLimitType,accept,fileList } = this.state;
        const { fileSizeLimit } = this.props;
        if(file.size>fileSizeLimit){
            message.warning(__getServerLanguage('ZongWenJianDaXiaoChaoChuXianZhi', this.formatBytes(fileSizeLimit)));
            return false;
        }
        if(accept){
            const sSuffix = getFileSuffix(file.name);
            const inx = accept.indexOf(sSuffix);
            if(inx<0){
                // 文件格式不正确，不能上传
                message.warning(__getServerLanguage("WenJianGeShiBuZhengQue"))
                return false;
            }
        }
        if(flagLimitType){ // 检查是不在可检查类型中
            if((files.length>1||fileList.length>0)){ // 如果限制类型，同一队列中有不同类型默认不可同时上传
                let type = '';
                // 检查 是否匹配准备上传队列 结束后 type必有值
                for(let key of files) {
                    const currType = this.checkType(getFileSuffix(key.name));
                    if (!isEmpty(type) && type !== currType) {
                        return false
                    }else type = currType;
                }
                // 检查 是否匹配已有列表
                for(let oldFile of fileList) {
                    const currType = this.checkType(oldFile.name);
                    if (type !== currType) {
                        return false
                    }
                }
            }
        }
        return true
    }
    /**
     * 上传成功回调
     * */
    uploadSuccess(respModel){
        const sType = this.checkType(respModel.extend);
        const { maxCount } = this.props;
        const { loadInx } = this.state;
        const newFile = {
            uid:respModel.id,
            name:respModel.realName+'.'+respModel.extend,
            fileName:respModel.realName+'.'+respModel.extend, // 对接后端保存时用此字段
            fileExtend:respModel.extend,
            fileId:respModel.id,
            fileUrl:respModel.url,
            type: sType,
            status: 'done',
        };
        if(maxCount==1){ // 如果最大上传数为1即更新列队为此上传文件
            const fileList = [newFile];
            this.props.onChange(fileList);
            this.setState({
                fileList:fileList,
            });
        }else {
            let fileList = [ ...this.state.fileList];
            if(fileList.length==0)this.setAccept(newFile); // 如果原文件列表为0才去判断是否限制文件类型
            if(!isEmpty(loadInx)){
                fileList[loadInx] = newFile;
                this.setState({
                    fileList: fileList,
                    loadInx:''
                });
            }else {
                fileList.push(newFile)
                this.setState({
                    fileList: fileList,
                });
            }
            this.props.onChange(fileList);
        }
    }
    /**
     * 上传 框
     * */
    renderUploadBox(accept='*',tips='',inx=0){
        const {placeholder,disabled } = this.props;
        return (<div className={"ant-upload-list-picture-card-container"}>
            <div className={"ant-upload ant-upload-select ant-upload-select-picture-card"} style={disabled?{"cursor":"not-allowed"}:{}}>
                <label tabIndex="0" className="ant-upload" role="button" style={disabled?{"cursor":"not-allowed"}:{}}>
                    {!disabled&&<input type="file" style={{ display: 'none' }} onChange={(e)=>this.upload(e,inx)} accept={accept} />}
                    <div>
                        < i className="ri-add-line black89 font_18"></i>
                        {placeholder&&<div className="black66 lineH_18">{placeholder}</div>}
                    </div>
                </label>
            </div>
            {tips&&<p>{tips}</p>}
        </div>)
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    componentWillMount() {
    }
    componentDidMount() {
        const that = this;
        this.init(function (file, response={}) {
            that.loading(false);
            const {success,valid,model} = response;
            if(success&&valid){
                that.uploadSuccess(model)
            }else message.warning(__getServerLanguage("ShangChuanShiBai"))
        });
    }
    render() {
        const { disabled,maxCount, fileSizeLimit, styleUpload,styleName } = this.props;
        const { fileList, previewVisible, previewImage,accept, loading } = this.state;
        console.log("disabled",disabled)
        return (<Spin spinning={loading}>
            {/* 根据样式处理 显示 */}
            {styleUpload=='RU_IDcard'?<div className={styleName?"upload-rs_IDcard "+styleName:"upload-rs_IDcard"}>
                {/* 俄罗斯 证件示例样式 */}
                <p className={"tips"}>
                    {Lang({id: 'QingShangChuanFenXiaoShangDeZhengJianZhaoPian', default: '请上传分销商的证件照片'})}
                </p>
                <div className={"ant-upload-list ant-upload-list-picture-card"}>
                    {fileList.length>0?this.renderOne(fileList[0],accept,0):this.renderUploadBox(accept,__getServerLanguage("ShangChuanTuPian"))}
                </div>
                {!disabled&&<div className={"ant-upload-list ant-upload-list-picture-card"}>
                    <div className={"ant-upload-list-picture-card-container"}>
                        <span>
                            <div className={"ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card"}>
                                <div className="ant-upload-list-item-info">
                                    <span><a
                                        className="ant-upload-list-item-thumbnail"
                                        target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={"https://oss.essaone.com/3a070aef-d16d-4e1e-89e1-6d5c620bb902.png"} className="ant-upload-list-item-image" />
                                        </a>
                                    </span>
                                </div>
                                <span className="ant-upload-list-item-actions">
                                    <span className={'action cursor-p'} onClick={()=>this.handlePreview("https://oss.essaone.com/3a070aef-d16d-4e1e-89e1-6d5c620bb902.png")}><i className="ri-eye-line color-white"> </i></span>
                                </span>
                            </div>
                        </span>
                        <p>{__getServerLanguage("ShiLi")}</p>
                    </div>
                </div>}
            </div>:<div className={styleName?styleName+" ant-upload-picture-card-wrapper":"ant-upload-picture-card-wrapper"}>
                <div className={"ant-upload-list ant-upload-list-picture-card"}>
                    {fileList.length>0&&this.renderList(fileList,accept)}
                </div>
                {fileList.length<maxCount&&this.renderUploadBox(accept)}
                {styleUpload=='avatar'&&!disabled&&<div className={"avatar-box"}>
                    <div className={"avatar-title"}>{__getServerLanguage("TouXiang")}</div>
                    {/*<p>最大支持{this.formatBytes(fileSizeLimit)}，支持{this.showAccept(accept)}格式</p>*/}
                    <p>{__getServerLanguage('ZuiDaZhiChiShangChuanWenJianYaoQiu',this.formatBytes(fileSizeLimit),this.showAccept(accept))}</p>
                    <div className={"btn-upload"}>
                        <label tabIndex="0" className="ant-upload" role="button">
                            <input type="file" style={{ display: 'none' }} onChange={(e)=>this.upload(e)} accept={accept} />
                            {__getServerLanguage("ShangChuanTuPian")}
                        </label>
                    </div>
                </div>}
            </div>}

            <Modal open={previewVisible} footer={null} onCancel={this.handleCancel}>
                <img style={{ width: '100%' }} src={previewImage} />
            </Modal>

        </Spin>);
    }
}


export default UploadImageComponent;
